<div class='table table-striped col'>
  <div class='table-header row secondary-color text-white mt-3'>
    <div class="cell-data col-3">Sub Scale</div>
    <div class="cell-data col-3">Description</div>
    <div class="cell-data col-3">Raw Score</div>
    <div class="cell-data col-3">Range <i class="fa fa-clipboard float-right" (click)="copyTable()" title="Copy Table" alt="Copy Table"></i></div>
  </div>
  <div *ngFor="let scaleResult of SubScales" class="row">
    <div class="cell-data col-3">
      {{scaleResult.scale.name}}
    </div>
    <div class="cell-data col-3 text-small">
      {{scaleResult.scale.descriptionClient}}
    </div>
    <div class="cell-data col-3">
      {{scaleResult.score}}
    </div>
    <div class="cell-data col-3">
      {{scaleResult.range.name}}
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/reports/scale-sub-list/scale-sub-list.component.html